import DropdownSelector from 'components/DropdownSelector';
import OvalDisplayHorizontal from 'components/OvalDisplayHorizontal';
import React, { useContext, useEffect, useState } from 'react';
import { PiWavesBold } from 'react-icons/pi';
import * as colorUtils from 'utils/colorUtils';
import { ErrorMessage } from './ErrorMessage';
import WidgetLoadingAnimation from './WidgetLoadingAnimation';
import WidgetTimeUpdate from './WidgetTimeUpdate';

//images inports
import { LayoutSizeContext, UniqueWidgetRefreshContext } from 'App';
import { BasePlatform } from 'chart.js';
import { useAPIData } from 'hooks/useAPIData';
import Cookies from 'js-cookie';
import { getAirQualityObservation } from 'services/weather/airQuality.service';
import GoodImg from '../../assets/airquality/1.png';
import ModerateImg from '../../assets/airquality/2.png';
import UnhealthySImg from '../../assets/airquality/3.png';
import UnhealthyImg from '../../assets/airquality/4.png';
import VeryUnhealthyImg from '../../assets/airquality/5.png';
import HazardousImg from '../../assets/airquality/6.png';

const imageMap = {
  G: { img: GoodImg, text: 'Good' },
  M: { img: ModerateImg, text: 'Moderate' },
  S: { img: UnhealthySImg, text: 'Unhealthy for Sensitive Groups' },
  U: { img: UnhealthyImg, text: 'Unhealthy' },
  V: { img: VeryUnhealthyImg, text: 'Very Unhealthy' },
  H: { img: HazardousImg, text: 'Hazardous' },
};

let dataCache;

export default function AirQualityObservationsWidget({
  widgetRefresh,
  setWidgetRefresh,
  dimensions,
}) {
  const [data, setData] = useState();
  const [selected, setSelected] = useState(0);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState({ state: false, message: '' });
  const layout = useContext(LayoutSizeContext);
  // const [widgetRefresh, setWidgetRefresh] = useState(false);
  const FusionData = useAPIData({
    successCallback: () => {
      setFetching(false);
    },
    errorCallback: () => {
      setError({ state: true, message: 'Error fetching data' });
      setFetching(false);
    },
    fetchingCallback: () => {
      setFetching(true);
    },
  });

  useEffect(() => {
    dataCache = null;
    setFetching(true);
  }, [widgetRefresh]);

  const uwf = useContext(UniqueWidgetRefreshContext);
  const ROUTE = 'getAirQualityObservation';
  const LOCATION = Cookies.get('city') + '-' + Cookies.get('state');
  const UNIQUEKEY = LOCATION + '-' + ROUTE;

  useEffect(() => {
    const fetchData = async () => {
      try {
        FusionData.forceGet({
          key: ROUTE,
          apiFunction: getAirQualityObservation,
        }).then((res) => {
          dataCache = [...res.data.result];
          setData(dataCache);

          setFetching(false);
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setFetching(false);
      }
    };

    fetchData();
  }, [uwf[UNIQUEKEY]]);

  useEffect(() => {
    (async () => {
      if (dataCache) {
        setData(dataCache);
        setFetching(false);
        return;
      }
      FusionData.get({
        key: ROUTE,
        apiFunction: getAirQualityObservation,
      })
        .then((res) => {
          dataCache = [...res.data.result];
          setData(dataCache);

          setFetching(false);
        })
        .catch((err) => {
          setError({ state: true, message: err.message });
        });
    })();
  }, [widgetRefresh]);

  if (error.state && !fetching) {
    return (
      <ErrorMessage
        message={error.message}
        retryRoute={ROUTE}
        onRetry={() => {
          setError({ state: false, message: '' });
          setFetching(true);
        }}
      />
    );
  }

  // if (true)
  if (fetching)
    return <WidgetLoadingAnimation widgetName={'AirQualityObservation'} dimensions={dimensions} />;
  if (data && data.length === 0) {
    return (
      <div>
        <WidgetTimeUpdate route={ROUTE} />
        <div style={{ padding: 15 }}>No data found.</div>
      </div>
    );
  }
  if (dimensions[0] == 1 && dimensions[1] == 2)
    if (data)
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <WidgetTimeUpdate route={ROUTE} />
          {data.length && (
            <div
              // className="scrollbar-hidden"
              style={{ padding: 15 }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  overflow: 'auto',
                  maxHeight: 950,
                }}
              >
                <div style={{ flex: 1 }}>
                  {data.map((item, index) => {
                    return (
                      <OvalDisplayHorizontal
                        key={index}
                        style={{ margin: 15 }}
                        header={item.air_station_name}
                        headerStyle={{ fontSize: 15 }}
                        content={
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              width: '100%',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              fontSize: 12,
                            }}
                          >
                            <div>{`Concentration: ${item.concentration}ppb`}</div>
                            <PiWavesBold
                              size={25}
                              color={colorUtils.GetQualityColor(item.category)}
                            />
                          </div>
                        }
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      );
  if (dimensions[0] == 1 && dimensions[1] == 1) {
    if (data)
      return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <WidgetTimeUpdate route={ROUTE} />

          {data.length && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: 10,
                flex: 1,
                minHeight: 0,
              }}
            >
              <div style={{ zIndex: 1000, marginBottom: 8, flexShrink: 0 }}>
                <DropdownSelector
                  options={data.map((item) => {
                    return item.air_station_name;
                  })}
                  selectedOption={selected}
                  setSelected={(index) => setSelected(index)}
                  triggerStyle={{ width: '100%', padding: 5, zIndex: 1000 }}
                  contentStyle={{ border: 'solid black 2px' }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  height: '100%',
                  minHeight: 0,
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    flex: '1 1 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                    minHeight: 0,
                  }}
                >
                  <div
                    style={{
                      marginTop: 4,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      flex: 1,
                      minHeight: 0,
                    }}
                  >
                    <img
                      src={imageMap[data[selected].category].img}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                  <div
                    style={{
                      flexShrink: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      marginTop: `calc(-34% - ${layout.scaleMult * 60 - 60}px)`,
                      paddingBottom: 6,
                    }}
                  >
                    <PiWavesBold
                      size={Math.max(42, Math.min(72, 56 * layout.scaleMult))}
                      color={colorUtils.GetQualityColor(data[selected].category)}
                    />
                    <div
                      style={{
                        fontSize: Math.max(28, Math.min(54, 34 * layout.scaleMult)),
                        lineHeight: 1,
                      }}
                    >
                      {imageMap[data[selected].category].text}
                    </div>
                  </div>
                  <div
                    style={{
                      width: '100%',
                      flexShrink: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      paddingTop: 6,
                    }}
                  >
                    <div
                      style={{ marginBottom: 2, fontSize: Math.max(11, layout.baseFontSize - 1) }}
                    >
                      {`Concentration: ${data[selected].concentration}ppb`}
                    </div>
                    <div
                      style={{
                        fontSize: Math.max(10, layout.baseFontSize - 2),
                        lineHeight: 1.2,
                        textAlign: 'center',
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {data[selected].description}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
  }

  if (dimensions[0] == 2 && dimensions[1] == 1) {
    if (data)
      return (
        <div style={{ height: '100%' }}>
          <WidgetTimeUpdate route={ROUTE} />
          {data.length && (
            <div
              // className="scrollbar-hidden"
              style={{ padding: 15, maxHeight: '85%' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  overflowY: 'auto',
                  // height: 400,
                }}
              >
                <div style={{ flex: 1 }}>
                  {data
                    .filter((item, index) => {
                      return index % 2 == 0;
                    })
                    .map((item, index) => {
                      return (
                        <OvalDisplayHorizontal
                          key={index}
                          style={{ margin: 15 }}
                          header={item.air_station_name}
                          headerStyle={{ fontSize: 15 }}
                          content={
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: 12,
                              }}
                            >
                              <div>{`Concentration: ${item.concentration}ppb`}</div>
                              <PiWavesBold
                                size={25}
                                color={colorUtils.GetQualityColor(item.category)}
                              />
                            </div>
                          }
                        />
                      );
                    })}
                </div>
                <div style={{ flex: 1 }}>
                  {data
                    .filter((item, index) => {
                      return index % 2 == 1;
                    })
                    .map((item, index) => {
                      return (
                        <OvalDisplayHorizontal
                          key={index}
                          style={{ margin: 15 }}
                          header={item.air_station_name}
                          headerStyle={{ fontSize: 15 }}
                          content={
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: 12,
                              }}
                            >
                              <div>{`Concentration: ${item.concentration}ppb`}</div>
                              <PiWavesBold
                                size={25}
                                color={colorUtils.GetQualityColor(item.category)}
                              />
                            </div>
                          }
                        />
                      );
                    })}
                </div>
              </div>
            </div>
          )}
        </div>
      );
  }

  return (
    <div>
      <div style={{ padding: 15 }}>No data found</div>
    </div>
  );
}
